import React from "react";
import { Styleable } from "../../types";

interface VisitedPinProps extends Styleable {
  width?: number;
  height?: number;
}

export default function VisitedPin({
  width = 20,
  height = (width / 29) * 44,
  ...props
}: VisitedPinProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 29 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.4995 38C18.0653 38 20.956 38.753 20.956 39.6818C20.956 40.6107 18.0653 41.3636 14.4995 41.3636C10.9337 41.3636 8.04297 40.6107 8.04297 39.6818C8.04297 38.753 10.9337 38 14.4995 38Z"
          fill="white"
          fillOpacity="0.01"
        />
      </g>
      <mask
        id="path-2-outside-1"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="29"
        height="40"
        fill="black"
      >
        <rect fill="white" width="29" height="40" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.5 38C14.5 38 28 21.224 28 14.0285C28 6.83306 21.9558 1 14.5 1C7.04416 1 1 6.83306 1 14.0285C1 21.224 14.5 38 14.5 38Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 38C14.5 38 28 21.224 28 14.0285C28 6.83306 21.9558 1 14.5 1C7.04416 1 1 6.83306 1 14.0285C1 21.224 14.5 38 14.5 38Z"
        fill="#0D5257"
      />
      <path
        d="M14.5 38L13.7209 38.6269L14.5 39.5951L15.2791 38.6269L14.5 38ZM14.5 38C15.2791 38.6269 15.2792 38.6268 15.2794 38.6266C15.2795 38.6264 15.2797 38.6262 15.2799 38.6258C15.2804 38.6252 15.2811 38.6244 15.282 38.6232C15.2839 38.621 15.2865 38.6177 15.2899 38.6135C15.2967 38.6049 15.3068 38.5924 15.3199 38.576C15.3462 38.5431 15.3848 38.4946 15.435 38.4314C15.5354 38.3048 15.682 38.1191 15.8683 37.8805C16.2407 37.4035 16.7719 36.7151 17.409 35.8668C18.6823 34.1714 20.3821 31.8328 22.0836 29.2649C23.7828 26.7005 25.4963 23.8887 26.7887 21.2494C28.0621 18.6491 29 16.0735 29 14.0285H27C27 15.5813 26.2504 17.801 24.9925 20.3699C23.7537 22.8998 22.0922 25.6311 20.4164 28.1602C18.7429 30.6857 17.0677 32.9909 15.8098 34.6658C15.1812 35.5028 14.6577 36.1812 14.2919 36.6497C14.109 36.8839 13.9656 37.0656 13.8682 37.1883C13.8195 37.2497 13.7824 37.2963 13.7575 37.3273C13.7451 37.3429 13.7358 37.3545 13.7297 37.3622C13.7266 37.366 13.7243 37.3688 13.7229 37.3706C13.7221 37.3716 13.7216 37.3722 13.7213 37.3726C13.7211 37.3728 13.721 37.3729 13.721 37.373C13.7209 37.3731 13.7209 37.3731 14.5 38ZM29 14.0285C29 6.24757 22.4743 0 14.5 0V2C21.4374 2 27 7.41856 27 14.0285H29ZM14.5 0C6.52568 0 0 6.24757 0 14.0285H2C2 7.41856 7.56263 2 14.5 2V0ZM0 14.0285C0 16.0735 0.937935 18.6491 2.21127 21.2494C3.50367 23.8887 5.2172 26.7005 6.91639 29.2649C8.61794 31.8328 10.3177 34.1714 11.591 35.8668C12.2281 36.7151 12.7592 37.4035 13.1317 37.8805C13.318 38.1191 13.4646 38.3048 13.565 38.4314C13.6152 38.4946 13.6538 38.5431 13.6801 38.576C13.6932 38.5924 13.7033 38.6049 13.7101 38.6135C13.7135 38.6177 13.7161 38.621 13.718 38.6232C13.7189 38.6244 13.7196 38.6252 13.7201 38.6258C13.7203 38.6262 13.7205 38.6264 13.7206 38.6266C13.7208 38.6268 13.7209 38.6269 14.5 38C15.2791 37.3731 15.2791 37.3731 15.279 37.373C15.279 37.3729 15.2789 37.3728 15.2787 37.3726C15.2784 37.3722 15.2779 37.3716 15.2771 37.3706C15.2757 37.3688 15.2734 37.366 15.2703 37.3622C15.2642 37.3545 15.2549 37.3429 15.2424 37.3273C15.2176 37.2963 15.1805 37.2497 15.1318 37.1883C15.0344 37.0656 14.891 36.8839 14.7081 36.6497C14.3423 36.1812 13.8188 35.5028 13.1902 34.6658C11.9323 32.9909 10.2571 30.6857 8.5836 28.1602C6.9078 25.6311 5.24633 22.8998 4.00748 20.3699C2.74957 17.801 2 15.5813 2 14.0285H0Z"
        fill="white"
        mask="url(#path-2-outside-1)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 16.8122L13.5904 22L23 12.6017L20.2096 10L13.4869 16.7173L10.6982 14.1188L8 16.8122H8Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d"
          x="6.04297"
          y="36"
          width="16.913"
          height="7.36364"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}
